// extracted by mini-css-extract-plugin
export default {"item-list":"SaladsMobile_item-list__HQv0x","item":"SaladsMobile_item__UfoRI","category-title":"SaladsMobile_category-title__pGvmB"};